export class PaymentSortField {
    static readonly PublisherGroupName: number = 0;
    static readonly RevenueMonth: number = 1;
    static readonly Amount: number = 2;
    static readonly Status: number = 3;
    static readonly PaymentDate: number = 4;
}


// WEBPACK FOOTER //
// ./src/app/payment/payment-sort.enum.ts